import { ReactNode } from 'react';

import { cn } from '@/app/shared/lib/cn';

export interface ReferralActionRowProps {
  title: string;
  description: string;
  children: ReactNode;
  className?: string;
}

const ReferralActionRow = ({ title, description, children, className }: ReferralActionRowProps) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-5 rounded-lg bg-elevated-card-2 p-5 lg:flex-row lg:items-start lg:gap-5',
        className,
      )}
    >
      <div className='flex w-full shrink-0 flex-col gap-1.5 lg:max-w-88.25'>
        <h2 className='text-base font-medium text-brand-1100'>{title}</h2>
        <p className='text-base leading-6 font-normal text-gray-400'>{description}</p>
      </div>

      <div className='flex min-w-0 flex-1 flex-col'>{children}</div>
    </div>
  );
};

export default ReferralActionRow;
